
  function waitForTestLoaded(maxWait = 1500, interval = 50) {
    return new Promise((resolve) => {
      let waited = 0;

      const timer = setInterval(() => {
        waited += interval;

        if (typeof window.testLoaded !== 'undefined') {
          clearInterval(timer);
          resolve(window.testLoaded);
          //console.log('Test 1 - Found');
        } else if (waited >= maxWait) {
          clearInterval(timer);
          resolve(false);
          //console.log('Test 2 - Timeout');
        } else {
          //console.log('Test 3 - Still waiting...');
        }
      }, interval);
    });
  }

  (async function() {
    const isTestRunning = await waitForTestLoaded();

    const currentPath = window.location.pathname;

    // --- Update menu link ---
      const menuLinks = document.querySelectorAll(
        'a[href="https://www.yagcho.de/a/collections/products"], a[href="/a/collections/products"]'
      );

      //menuLinks.forEach((menuLink) => {
        //menuLink.href = isTestRunning
          //? "https://www.yagcho.de/collections/shop-all"
        //  : "https://www.yagcho.de/collections/alle-producte";
      //});


    // --- Redirect rules ---
    const redirectRules = isTestRunning
      ? {
          "/collections/alle-producte": "/collections/shop-all",
          "/products/yagcho-neuro": "/products/anti-stress-komplex-v1",
          "/products/yagcho-flora": "/products/darmflora-komplex-v1",
          "/products/yagcho-immun": "/products/immun-energie-komplex",
        }
      : {
          "/collections/shop-all": "/collections/alle-producte",
          "/products/anti-stress-komplex-v1": "/products/yagcho-neuro",
          "/products/darmflora-komplex-v1": "/products/yagcho-flora",
          "/products/immun-energie-komplex": "/products/yagcho-immun",
        };

    if (redirectRules[currentPath]) {
      window.location.replace(redirectRules[currentPath]);
    }

    const cssPages = [
      "/products/anti-stress-komplex-v1",
      "/products/darmflora-komplex-v1",
      "/products/immun-energie-komplex"
    ];

    if (cssPages.includes(currentPath)) {
      var style = document.createElement("style");
        style.innerHTML = `
          body .shogun-root div#s-7107eff8-c65a-48b0-afc1-948898fe7e8e,
          body .shogun-root div#s-983c40c8-5699-42f2-89bf-b9bc86ba05d8,
          body .shogun-root div#s-869b1292-3b47-47d0-b826-239b3e78e8a0,
          body .shogun-root div#s-4a68ba69-947f-48a1-87a5-74b5813931f4,
          body .shogun-root div#s-d52efc1f-cc47-4672-bdaf-ab19f84fbad9,
          body .shogun-root div#s-7a7a3fe0-1386-406b-ba54-b92f97b6b39a
          {
              display: none !important;
          }
          `;
        document.head.appendChild(style);
      //console.log("Custom CSS injected for:", currentPath);
    }

  })();



// window.addEventListener("load", (event) => {
//   const isTestRunning = window.testLoaded;

//   const currentPath = window.location.pathname;

//   // --- Update menu link ---
//   const menuLink = document.querySelector('a[href="https://www.yagcho.de/a/collections/products"]');
//   if (menuLink) {
//     menuLink.href = isTestRunning
//       ? "https://www.yagcho.de/collections/shop-all?view=all"
//       : "https://www.yagcho.de/collections/all?view=all";
//   }

//   // --- Redirect rules ---
//   const redirectRules = isTestRunning
//     ? {
//         "/collections/all": "/collections/shop-all?view=all",
//         "/products/yagcho-neuro": "/products/anti-stress-komplex-v1",
//         "/products/yagcho-flora": "/products/darmflora-komplex-v1",
//       }
//     : {
//         "/collections/shop-all": "/collections/all?view=all",
//         "/products/anti-stress-komplex-v1": "/products/yagcho-neuro",
//         "/products/darmflora-komplex-v1": "/products/yagcho-flora",
//       };

//   if (redirectRules[currentPath]) {
//     window.location.replace(redirectRules[currentPath]);
//   }

//   const cssPages = [
//     "/products/anti-stress-komplex-v1",
//     "/products/darmflora-komplex-v1"
//   ];

//   if (cssPages.includes(currentPath)) {
//     var style = document.createElement("style");
//       style.innerHTML = `
//         body.template-product .shogun-root div#s-7107eff8-c65a-48b0-afc1-948898fe7e8e,
//         body.template-product .shogun-root div#s-983c40c8-5699-42f2-89bf-b9bc86ba05d8,
//         body.template-product .shogun-root div#s-869b1292-3b47-47d0-b826-239b3e78e8a0,
//         body.template-product .shogun-root div#s-4a68ba69-947f-48a1-87a5-74b5813931f4
//         {
//             display: none;
//         }
//         `;
//       document.head.appendChild(style);
//     //console.log("Custom CSS injected for:", currentPath);
//   }
// });


// Generate A/B Test Product

// window.addEventListener("load", (event) => {
//   const isTestRunning = window.testLoaded;
document.addEventListener("DOMContentLoaded", async () => {
  const isTestRunning = await waitForTestLoaded();
  if (!isTestRunning) return; 

  const productReplacements = JSON.parse(
    document.getElementById("yagcho-product_replacements").textContent
  );

  async function fetchProductData(handle) {
    try {
      const url = `/products/${handle}.js`;
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`Fetch failed for handle ${handle}, status: ${res.status}`);
      }
      const product = await res.json();
      return product;
    } catch (err) {
      console.error("Product fetch error for", handle, err);
      return null;
    }
  }

  async function checkCartForVariant(variantId) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      const item = cart.items.find(item => item.variant_id === variantId);
      return { exists: !!item, quantity: item ? item.quantity : 0 };
    } catch (err) {
      console.error("Cart check error:", err);
      return { exists: false, quantity: 0 };
    }
  }

  function generateProductCard(
    product,
    customDescription = "",
    reviewId,
    reviewRating,
    reviewRaters
  ) {
    const formatPrice = (amount) => {
      let formatted = theme.Currency.formatMoney(amount, theme.moneyFormat);
      formatted = formatted.replace(/\s?EUR/i, "").trim();
      return formatted.replace(",", ".");
    };

    const li = document.createElement("li");
    li.className = "custom-cart__upsell-product";

    const variantOptions = product.variants.map((variant, index) => {
      const hasDiscount =
        variant.compare_at_price && variant.compare_at_price > variant.price;

      return `
        <div class="variant-option boost-select__option ${index === 0 ? "selected" : ""}"
          data-id="${variant.id}" 
          data-price="${variant.price}" 
          data-compare="${variant.compare_at_price}" 
          data-image="${
            variant.featured_image
              ? variant.featured_image.src
              : product.featured_image
          }" 
          data-title="${variant.title}"
          ${!variant.available ? "data-disabled='true'" : ""}
        >
          <div class="boost-cart__product-variant-title">${variant.title}</div>
          <div class="boost-cart__product-variant-info">
            <div class="boost-cart__product-variant-price">
              ${
                hasDiscount
                  ? `
                    <s>${formatPrice(variant.compare_at_price)}</s> 
                    <span class="discounted-price">${formatPrice(
                      variant.price
                    )}</span>
                  `
                  : `${formatPrice(variant.price)}`
              }
            </div>
          </div>
        </div>
      `;
    }).join("");

    const priceDiscount =
        product.compare_at_price && product.compare_at_price > product.price;

    li.innerHTML = `
      <div class="boost-cart__upsell-product">
        <a href="${product.url}" class="boost-cart__upsell-product-image">
          <img src="${product.featured_image}" alt="${product.title}">
        </a>
        <div class="boost-cart__upsell-product-reviews" title="Rating">
          <div class="loox-rating" 
              data-id="${reviewId}" 
              data-rating="${reviewRating}" 
              data-raters="${reviewRaters}"
              style="display: flex;">
          </div>
        </div>
        <a href="${product.url}" class="boost-cart__upsell-product-title">${product.title}</a>
        <p class="boost-cart__upsell-product-description">${customDescription}</p>
        
        <div class="boost-cart__product-variants"> 
          <details class="boost-select">
            <summary class="boost-select__label">
              <span>Einzelpackung</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" fill="none" viewBox="0 0 11 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M10 .812256 5.712 5.09986c-.02784.02788-.06088.04996-.09724.06504-.0364.01512-.0754.02288-.11476.02288-.03936 0-.07836-.00776-.11476-.02288-.03636-.01508-.0694-.03716-.09724-.06504L1 .812256"></path>
              </svg>
            </summary>
            <div class="variant-options-list boost-cart__product-variant-options boost-select__options">
              ${variantOptions}
            </div>
          </details>
        </div>

        <div class="boost-cart__upsell-product-price">
          ${
              priceDiscount
                ? `
                  <s>${formatPrice(product.compare_at_price)}</s> 
                  <span class="discounted-price">${formatPrice(
                    product.price
                  )}</span>
                `
                : `${formatPrice(product.price)}`
            }
        </div>
        
        <div class="boost-cart__product-action"></div>
      </div>
    `;

    // Variant Click, Change Events
    const priceEl = li.querySelector(".boost-cart__upsell-product-price");
    const imageEl = li.querySelector(".boost-cart__upsell-product-image img");
    const summaryLabel = li.querySelector(".boost-select__label span");
    const actionDiv = li.querySelector(".boost-cart__product-action");

    let currentVariantId = null;

    li.querySelectorAll(".variant-option").forEach((option) => {
      option.addEventListener("click", async () => {
        li.querySelectorAll(".variant-option").forEach((opt) => opt.classList.remove("selected"));
        option.classList.add("selected");

        const price = parseInt(option.dataset.price, 10);
        const compare = parseInt(option.dataset.compare, 10);
        const newImage = option.dataset.image;
        const title = option.dataset.title;
        currentVariantId = parseInt(option.dataset.id, 10);
        const Discount = compare && compare > price;

        priceEl.innerHTML = `
          ${
              Discount
                ? `
                  <s>${formatPrice(compare)}</s> 
                  <span class="discounted-price">${formatPrice(
                    price
                  )}</span>
                `
                : `${formatPrice(price)}`
            }
        `;

        if (newImage) {
          imageEl.src = newImage;
        }

        summaryLabel.textContent = title;
        option.closest("details").removeAttribute("open");

        // Check if variant is in cart and update action
        const { exists, quantity } = await checkCartForVariant(currentVariantId);
        updateActionButton(actionDiv, currentVariantId, exists, quantity);
      });
    });

    li.querySelector(".variant-option.selected").click();

    return li;
  }

  function updateActionButton(actionDiv, variantId, isInCart, cartQuantity = 1) {
      actionDiv.innerHTML = isInCart
        ? `
          <div class="boost-cart__product-quantity boost-cart__quantity-control">
              <button class="boost-cart__product--decrement boost-cart__quantity-minus">
                <span class="boost-circle-loading">
                  <span class="boost-circle-loading__circle">
                    <span class="loader"></span>
                  </span>
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 4.27242h18M8.15893 14.7042V8.56783m3.68227 6.13637V8.56786m0-7.568104H8.15943c-.32549 0-.63765.129304-.86781.359464-.23016.23015-.35946.54232-.35946.86781v2.04545h6.13634V2.22703c0-.32549-.1293-.63766-.3594-.86781-.2302-.23016-.5424-.359464-.8679-.359464ZM15.6127 17.8705c-.0227.3075-.1612.5949-.3874.8045-.2262.2095-.5233.3255-.8317.3246H5.60637c-.30832.0009-.60551-.1151-.83171-.3246-.2262-.2096-.36462-.497-.38738-.8045L3.25 4.27236h13.5L15.6127 17.8705Z"></path></svg>
              </button>
              <span class="boost-cart__product--count boost-cart__quantity">${cartQuantity}</span>
              <button class="boost-cart__product--increment boost-cart__quantity-plus">
                <span class="boost-circle-loading">
                  <span class="boost-circle-loading__circle">
                    <span class="loader"></span>
                  </span>
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.00003" d="M8.00208 1.00012 8.00207 15.0003m6.99803-6.99957H.999935"></path></svg>
              </button>
            </div>
        `
        : `
          <button class="boost-cart__product--add" id="product-atc_button">
            <span class="boost-circle-loading">
              <span class="boost-circle-loading__circle">
                <span class="loader"></span>
              </span>
              <span>Füge hinzu...</span>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.00003" d="M8.00208 1.00012 8.00207 15.0003m6.99803-6.99957H.999935"></path></svg>
            <span class="boost-circle-default">Hinzufügen</span>
          </button>
        `;

      if (isInCart) {
        const minusBtn = actionDiv.querySelector(".boost-cart__quantity-minus");
        const plusBtn = actionDiv.querySelector(".boost-cart__quantity-plus");
        const quantitySpan = actionDiv.querySelector(".boost-cart__quantity");

        function updateMinusIcon() {
          const quantity = parseInt(quantitySpan.textContent, 10);
          const minusSvg = minusBtn.querySelector("svg");
          minusSvg.outerHTML = quantity > 1
            ? `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="4" fill="none" viewBox="0 0 16 4"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.42254" d="M14 2H2"></path></svg>`
            : `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 4.27242h18M8.15893 14.7042V8.56783m3.68227 6.13637V8.56786m0-7.568104H8.15943c-.32549 0-.63765.129304-.86781.359464-.23016.23015-.35946.54232-.35946.86781v2.04545h6.13634V2.22703c0-.32549-.1293-.63766-.3594-.86781-.2302-.23016-.5424-.359464-.8679-.359464ZM15.6127 17.8705c-.0227.3075-.1612.5949-.3874.8045-.2262.2095-.5233.3255-.8317.3246H5.60637c-.30832.0009-.60551-.1151-.83171-.3246-.2262-.2096-.36462-.497-.38738-.8045L3.25 4.27236h13.5L15.6127 17.8705Z"></path></svg>`;
        }

        minusBtn.addEventListener("click", async () => {
          let quantity = parseInt(quantitySpan.textContent, 10);
          if (quantity > 1) {
            minusBtn.classList.add("loading");
            quantity--;
            quantitySpan.textContent = quantity;
            await updateCartQuantity(variantId, quantity);
            minusBtn.classList.remove("loading");
            updateMinusIcon();
          } else if (quantity === 1) {
            minusBtn.classList.add("loading");
            await updateCartQuantity(variantId, 0);
            minusBtn.classList.remove("loading");
            updateActionButton(actionDiv, variantId, false);
          }
        });

        plusBtn.addEventListener("click", async () => {
          let quantity = parseInt(quantitySpan.textContent, 10);
          plusBtn.classList.add("loading");
          quantity++;
          quantitySpan.textContent = quantity;
          await updateCartQuantity(variantId, quantity);
          plusBtn.classList.remove("loading");
          updateMinusIcon();
        });

        updateMinusIcon(); 

      } else {
        actionDiv.querySelector("#product-atc_button").addEventListener("click", async () => {
          const button = actionDiv.querySelector("#product-atc_button");
          button.classList.add("loading");

          const quantity = 1;
          const formData = {
            items: [
              {
                id: variantId,
                quantity: quantity
              }
            ]
          };

          try {
            const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(formData)
            });

            const data = await response.json();
            //console.log("Added to cart:", data);

            if (window.Boost && typeof window.Boost.Cart.refresh === "function") {
              window.Boost.Cart.refresh();
              setTimeout(() => {
                button.classList.remove("loading");
                updateActionButton(actionDiv, currentVariantId);
              }, 1000);
            }
          } catch (error) {
            console.error("Error adding to cart:", error);
          }
        });
      }
  }

  async function updateCartQuantity(variantId, quantity) {
      try {
        const formData = {
          updates: {
            [variantId]: quantity
          }
        };
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        });
        if (window.Boost && typeof window.Boost.Cart.refresh === "function") {
          window.Boost.Cart.refresh();
          updateActionButton(currentVariantId, quantity);
        }
      } catch (error) {
        console.error("Error updating cart quantity:", error);
      }
  }

  async function syncCartWithUpsells() {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await response.json();

      document.querySelectorAll(".custom-cart__upsell-product").forEach((productEl) => {
        const actionDiv = productEl.querySelector(".boost-cart__product-action");
        const selectedOption = productEl.querySelector(".variant-option.selected");
        if (!selectedOption || !actionDiv) return;

        const variantId = parseInt(selectedOption.dataset.id, 10);
        const itemInCart = cart.items.find((item) => item.variant_id === variantId);

        if (itemInCart) {
          updateActionButton(actionDiv, variantId, true, itemInCart.quantity);
          clearInterval();
        } else {
          updateActionButton(actionDiv, variantId, false, 0);
          clearInterval();
        }
      });
    } catch (err) {
      console.error("Error syncing cart with upsells:", err);
    }
  }

  setInterval(syncCartWithUpsells, 2000); 


    function observeElement(selector, callback, once = true) {
      const processed = new WeakSet();
      const check = () => {
        const elements = Array.from(document.querySelectorAll(selector)).filter(el => !processed.has(el));
        if (elements.length) {
          elements.forEach(el => processed.add(el));
          callback(elements);
          if (once && observer) {
            observer.disconnect();
          }
        }
      };
      const observer = new MutationObserver(check);
      observer.observe(document.body, { childList: true, subtree: true });
      check();
    }


    observeElement(".boost-cart__upsell", async (upsellContainers) => {
      for (const container of upsellContainers) {
        await replaceUpsellProducts(container);

        const childObserver = new MutationObserver(() => {
          replaceUpsellProducts(container);
        });
        childObserver.observe(container, { childList: true, subtree: true });
      }
    }, false);

    async function replaceUpsellProducts(container) {
      for (const mapping of productReplacements) {
        const { targetHandle, description, newHandle, id, rating, raters } = mapping;

        const targetAnchor = [...container.querySelectorAll('.boost-cart__upsell-product a')]
          .find(a => a.getAttribute("href")?.startsWith(`/products/${targetHandle}`));

        if (targetAnchor) {
          const targetProductEl = targetAnchor.closest(".boost-cart__upsell-product");
          if (!targetProductEl) return;

          const newData = await fetchProductData(newHandle);
          if (newData) {
            const newProductEl = generateProductCard(newData, description, id, rating, raters);
            targetProductEl.replaceWith(newProductEl);
          }
        }
      }
    }

    // Cart Empty Suggestion Product

    function SuggestionProductCard(
      product,
      reviewId,
      reviewRating,
      reviewRaters
    ) {

      const li = document.createElement("li");
      li.className = "suggestion-cart__product";
      li.innerHTML = `
        <a href="${product.url}" class="boost-cart__product">
        <div class="boost-cart__product-image">
        <div class="boost-cart__product-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10"><path fill="currentColor" d="M.948393 9.83728 9.83728.948393C9.94147.844206 10 .702898 10 .555556c0-.147343-.05853-.28865-.16272-.392837C9.7331.0585316 9.59179 0 9.44444 0a.55544944.55544944 0 0 0-.02874.00074416C9.27848.00785361 9.14877.0655604 9.05161.162718L.162927 9.0514C.0587399 9.15559 0 9.2971 0 9.44444c0 .14735.0585316.28866.162718.39284C.266905 9.94147.408213 10 .555556 10c.147342 0 .28865-.05853.392837-.16272Z"></path><path fill="currentColor" d="M8.88889 1.11111v6.66667c0 .30682.24873.55555.55555.55555.30683 0 .55556-.24873.55556-.55555V.555556C10 .248731 9.75127 0 9.44444 0H2.22222c-.30682 0-.55555.248731-.55555.555556 0 .306824.24873.555554.55555.555554h6.66667Z"></path></svg>
        </div>
          <img src="${product.featured_image}" alt="${product.title}"  width="128" height="128">
        </div>
        <div class="boost-cart__product-title">${product.title}</div>
        <div class="boost-cart__product-reviews" title="Rating">
            <div class="loox-rating" 
                data-id="${reviewId}" 
                data-rating="${reviewRating}" 
                data-raters="${reviewRaters}"
                style="display: flex;">
            </div>
          </div>
        </a>
      `;

      return li;
    }

    observeElement(".boost-cart__empty-suggestions", async (upsellContainers) => {
      for (const container of upsellContainers) {
        for (const mapping of productReplacements) {
          const { targetHandle, newHandle, id, rating, raters } = mapping;
          const targetSelector = `li a[href="/products/${targetHandle}"]`;
          const targetAnchor = container.querySelector(targetSelector);
          const targetProductEl = targetAnchor ? targetAnchor.closest("li") : null;
          if (targetProductEl) {
            const newData = await fetchProductData(newHandle);
            if (newData) {
              const newProductEl = SuggestionProductCard(newData, id, rating, raters);
              targetProductEl.replaceWith(newProductEl);
            }
          }
        }
      }
    }, false);


    observeElement(".boost-cart__footer", async (footerContainers) => {
      for (const container of footerContainers) {
       const menuLink = container.querySelector(
          'a[href="https://www.yagcho.de/a/collections/products"]'
        );
        // console.log("I am here", menuLink);
        if (menuLink) {
          menuLink.href = isTestRunning
            ? "https://www.yagcho.de/collections/shop-all"
            : "https://www.yagcho.de/collections/alle-producte";
          }
      }
    }, false);

});


